import { BaseModule } from "by/gamefactory/cityversetycoon/composition/module/BaseModule";
import { UserProfileResourcePackage } from "./resources/UserProfileResourcePackage";
import { UserProfileModuleFlowExecutor } from "./UserProfileModuleFlowExecutor";
import { ProfileController } from "./profile/controllers/ProfileController";
import { SignOutController } from "./signout/controllers/SignOutController";
import { ParamDescription } from "../../../composition/module/ParamDescription";
import { UserProfileResult } from "./profile/UserProfileResult";
import { UserProfilePopupScene, UserProfileSceneOptions } from "./profile/UserProfilePopupScene";
import { IUserLevelUpModel } from "../userlevelup/model/IUserLevelUpModel";

export class UserProfileModule extends BaseModule<UserProfileResult> {
    private userProfileResources: UserProfileResourcePackage;

    public override async build(): Promise<void> {
        this.internalContainer.register(UserProfileModuleFlowExecutor, UserProfileModuleFlowExecutor);

        this.internalContainer.register("IProfileController", ProfileController);
        this.internalContainer.register(UserProfilePopupScene, UserProfilePopupScene);
        this.internalContainer.register("ISignOutController", SignOutController);
        this.internalContainer.register("UserProfileSceneFactory", {
            useValue: async (options: UserProfileSceneOptions) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    UserProfilePopupScene,
                    new ParamDescription("UserProfileSceneOptions", options)
                );
            }
        });

        this.userProfileResources = new UserProfileResourcePackage();
        await this.userProfileResources.load();
        this.internalContainer.registerInstance(UserProfileResourcePackage, this.userProfileResources);
        await super.build();
    }

    public async start(userLevelModel?: IUserLevelUpModel): Promise<UserProfileResult> {
        const executor = await this.internalContainer.resolve(UserProfileModuleFlowExecutor);
        const result = await executor.execute(this, userLevelModel);
        this.dispose();
        return result;
    }

    public override dispose(): void {
        this.userProfileResources.destroy();
        super.dispose();
    }
}
